export default function (tasks) {
    return tasks.reduce((accumulatorPromise, task) => accumulatorPromise.then((result) => {
        if (result) {
            return Promise.resolve(result);
        }
        return task(result);
    }), Promise.resolve());
}
